import { regexOnlyNumber } from 'shell/constants/regex';
import * as yup from 'yup';
// import { FilterPracticeVM } from 'practice/view-models/practice-research';

export const validationSchemaFilterPractice = yup.object().shape({
  typeRegister: yup.string().nullable().required('Il campo è obbligatorio'),
  atNumber: yup.string().matches(regexOnlyNumber).nullable().min(0, 'Valore negativo'),
  fromNumber: yup
    .string()
    .nullable()
    .matches(regexOnlyNumber)
    .min(0, 'Valore negativo')
    .when('atNumber', (atNumber, formvalidationSchema) =>
      atNumber
        ? formvalidationSchema.max(atNumber, 'Il numero deve essere minore uguale di A numero')
        : formvalidationSchema.nullable()
    ),
  dateTo: yup.date().typeError('Data non valida').nullable(),
  dataDecorrenzaDa: yup.date().typeError('Data non valida').nullable(),
  dataDecorrenzaA: yup.date().typeError('Data non valida').nullable(),
  dateFrom: yup
    .date()
    .typeError('Data non valida')
    .nullable()
    .when('dateTo', (dateTo, formvalidationSchema) =>
      dateTo
        ? formvalidationSchema.max(dateTo, 'La data deve essere minore uguale di Data apertura al')
        : formvalidationSchema.nullable()
    ),
  years: yup.string().matches(regexOnlyNumber, 'Il campo non è valido'),
});
// .test('years', 'Controllo', (values) => {
//   const castedValues = values as unknown as FilterPracticeVM;

//   if (
//     castedValues.dateTo &&
//     castedValues.dateTo?.toString() !== 'Invalid Date' &&
//     castedValues.dateFrom &&
//     castedValues.dateFrom?.toString() !== 'Invalid Date' &&
//     !castedValues.years
//   ) {
//     return new yup.ValidationError('Il campo è obbligatorio', undefined, 'years');
//   }

//   return true;
// });

export const validationSchemaAssignOperator = yup.object().shape({
  newService: yup.string().required('Il campo è obbligatorio'),
  newOperator: yup.string().required('Il campo è obbligatorio'),
  reason: yup.string().required('Il campo è obbligatorio'),
});

export const validationSchemaPracticesAssignOperator = yup.object().shape({
  // newService: yup.string().required('Il campo è obbligatorio'),
  newOperator: yup.string().required('Il campo è obbligatorio'),
  // reason: yup.string().required('Il campo è obbligatorio'),
  practices: yup.array().min(1, 'Selezionare almeno un elemento dalla tabella'),
});
